import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  T_StockSliceState,
  T_StockDashboardDetails,
  T_CustomerData,
} from "./Stockc&Securities_Types";
import { T_menu } from "../Feature_GeneralAppElements/GeneralAppElements_Types";

const initialState: T_StockSliceState = {
  stockdashboardDetails: [],
  CustomerData: {},
  secondaryStockDashboardDetails: [],
  serviceMenuDetails:[],
};

export const StocksSlice = createSlice({
  name: "StocksSlice",
  initialState,
  reducers: {
    setStocksDashboardDetails: (
      state,
      action: PayloadAction<T_StockDashboardDetails[]>
    ) => {
      return {
        ...state,
        stockdashboardDetails: action.payload,
      };
    },
    setSecondaryStockDashboardDetails: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        secondaryStockDashboardDetails: action.payload,
      };
    },
    setUserDetails: (state, action: PayloadAction<T_CustomerData>) => {
      return {
        ...state,
        CustomerData: action.payload,
      };
    },
    setServiceMenuDetails:(state, action: PayloadAction<any>) => {
      return {
        ...state,
        serviceMenuDetails: action.payload,
      };
    },
  },
});

export const StocksSliceReducer = StocksSlice.reducer;
export const StocksSliceKey = StocksSlice.reducerPath;

export const {
  setStocksDashboardDetails,
  setSecondaryStockDashboardDetails,
  setUserDetails,
  setServiceMenuDetails
} = StocksSlice.actions;
